/**
 * Easier api calls
 */
// Seperate api domain in development. Server is unified when running in production
let apiDomain = ''
if (import.meta.env.DEV) {
  apiDomain = import.meta.env.VITE_API_DOMAIN
}
if (import.meta.env.SSR) {
  apiDomain = import.meta.env.VITE_SERVER_API_DOMAIN
}

export async function getPage(slug) {
  try {
    const response = await fetch(`${apiDomain}/api/pages/slug/${slug}`)
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching page:', error)
    throw error
  }
}
export async function getPageData(store, route) {
  return store.dispatch('fetchPage', route)
}
